import { createComponent, ElementWithProps } from '@carvana/merch-components';
import cx from 'classnames';

export const CardContainer = createComponent<
  ElementWithProps<{ isOnPage: boolean }>
>('div', props => ({
  className: cx(
    'flex gap-md m:gap-0',
    props.isOnPage ? 'm:flex-col' : 'flex-col'
  )
}));

export const CardSVG = createComponent('img', {
  className: 'h-32 w-32 m:h-56 m:w-56'
});

export const CardTitle = createComponent<
  ElementWithProps<{ biggerTitle: boolean }>
>('h3', props => ({
  className: cx('pt-4 text-blue-6 -:mb-md -:tl-header-m m:pt-0  -:m:mt-md', {
    'mb-2xl mt-4 tl-header-xl': props.biggerTitle
  })
}));

export const List = createComponent('ul', {
  className: 'flex list-inside list-disc flex-col gap-md marker:tl-body-xs'
});

export const ListItem = createComponent('li', {
  className: 'text-blue-6 tl-body-m'
});
